import React, { useCallback, useEffect, useRef } from "react";

import droneModel from "assets/img/3dmodel/animated_drone.glb";

const HomeStartUpAbout = () => {
  const modelViewerRef = useRef(null);

  const frameModelToBounds = useCallback((viewer) => {
    if (!viewer?.getBoundingBoxCenter || !viewer?.getDimensions) return;

    const center = viewer.getBoundingBoxCenter();
    const dimensions = viewer.getDimensions();
    const maxDimension = Math.max(dimensions.x, dimensions.y, dimensions.z);

    if (!Number.isFinite(maxDimension) || maxDimension <= 0) return;

    const cameraDistance = Math.max(maxDimension * 2.35, 0.35);
    const minDistance = Math.max(maxDimension * 0.9, 0.18);
    const maxDistance = Math.max(maxDimension * 7, 1.4);

    viewer.setAttribute(
      "camera-target",
      `${center.x}m ${center.y}m ${center.z}m`
    );
    viewer.setAttribute("camera-orbit", `35deg 64deg ${cameraDistance}m`);
    viewer.setAttribute("min-camera-orbit", `auto auto ${minDistance}m`);
    viewer.setAttribute("max-camera-orbit", `auto auto ${maxDistance}m`);
    viewer.setAttribute("field-of-view", "30deg");
  }, []);

  useEffect(() => {
    if (customElements.get("model-viewer")) return;
    if (document.querySelector('script[data-rionick-model-viewer="true"]')) return;

    const script = document.createElement("script");
    script.type = "module";
    script.src = "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
    script.dataset.rionickModelViewer = "true";
    document.head.appendChild(script);
  }, []);

  useEffect(() => {
    const viewer = modelViewerRef.current;
    if (!viewer) return undefined;

    const handleLoad = () => frameModelToBounds(viewer);
    viewer.addEventListener("load", handleLoad);

    if (viewer.loaded) {
      handleLoad();
    }

    return () => {
      viewer.removeEventListener("load", handleLoad);
    };
  }, [frameModelToBounds]);

  return (
    <section className="about__area interactive-showcase p-relative z-index-1">
      <div className="container">
        <div className="row align-items-center gy-5">
          <div className="col-xxl-6 col-lg-6">
            <div className="interactive-showcase__viewer">
              <div className="interactive-showcase__hud">
                {/* <span>Live Viewer</span>
                <span>Drag to inspect</span> */}
              </div>

              <div className="interactive-showcase__stage">
                <model-viewer
                  ref={modelViewerRef}
                  className="interactive-showcase__model"
                  style={{ width: "100%", height: "100%" }}
                  src={droneModel}
                  alt="Interactive 3D model"
                  camera-controls
                  auto-rotate
                  auto-rotate-delay="0"
                  rotation-per-second="12deg"
                  interaction-prompt="none"
                  shadow-intensity="1.35"
                  shadow-softness="0.8"
                  exposure="1.15"
                  environment-image="legacy"
                  camera-orbit="35deg 64deg auto"
                  field-of-view="30deg"
                  ar
                >
                  <div className="interactive-showcase__model-loading" slot="poster">
                    Loading 3D drone model
                  </div>
                </model-viewer>
              </div>

              <div className="interactive-showcase__controls">
                <span></span>
                <p>Drag to inspect the 3D Model</p>
              </div>
            </div>
          </div>

          <div className="col-xxl-6 col-lg-6">
            <div className="interactive-showcase__content">
              <span className="interactive-showcase__label">Interactive 3D Experiences</span>
              <h3>We Don't Just Design 3D. We Bring It to Life.</h3>
              <p>
                At Rionick Studios, every model is built to be experienced, not
                just viewed. From photorealistic product visualization and
                game-ready assets to AR experiences and interactive real estate
                walkthroughs, we create digital experiences that engage,
                impress, and help businesses showcase their ideas in the most
                immersive way possible.
              </p>
              <p>
                Instead of static images, our work is fully interactive,
                allowing users to explore, rotate, and experience products before
                they exist in the real world.
              </p>

              <div className="interactive-showcase__metrics">
                <div>
                  <strong>360</strong>
                  <span>Inspectable Assets</span>
                </div>
                <div>
                  <strong>AR</strong>
                  <span>Ready Experiences</span>
                </div>
                <div>
                  <strong>3D</strong>
                  <span>Real-time Workflows</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeStartUpAbout;
